<template>

  <div id="piece-container">

    <div v-if="isPortrait" class="piece-heading piece-heading-portrait">
      {{ t(props.piece) }}<br>{{ t("Guards") }}
    </div>
    <div v-else class="piece-heading">
      {{ t(props.piece) }} {{ t("Guards") }}
    </div>

    <div v-for="item in pieceList" v-bind:key="item.index">

      <div v-if="item.piece != props.piece">
        <button  class="btn guarding-button"
        :class="{
                  'error-border-dark' : item.goodAnswer && isDark,
                  'error-border-light' : item.goodAnswer && !isDark,
                  'selected-text-dark' : (item.selected) && isDark,
                  'not-selected-text-dark'     : (!(item.selected)) && isDark,
                  'selected-text-light' : (item.selected) && !isDark,
                  'not-selected-text-light'     : (!(item.selected)) && !isDark
                }"
                      @click="onClick($event,item.index)">
        {{ item.piece }}</button>
      </div>
      <div v-else class="just-text">
        {{ item.piece }}
      </div>
    </div>
  </div>
</template>

<script setup>

  import { useConnectionStore } from '@/stores/connectionStore';
  import { computed } from "@vue/reactivity"
  import { ref, watch } from 'vue'
  import { t } from '@/composables/translateText.js'

  const emit = defineEmits(['checkbox-click'])

  const props = defineProps({
    piece : String,
    isPortrait : {
      type : Boolean,
      default : false
    },
    setBackground : {
      type : String,
      default : ""
    },
    resetTrigger : {
      type : Number,
      default : 0
    },
  })

  const connectionStore = useConnectionStore()

  const isDark = ref(connectionStore.getDarkmode != "" && connectionStore.getDarkmode != "light")
  
  const pieceList = ref([ 
                      { index : 0, piece : t("Rook") , value : false , selected : false},
                      { index : 1, piece : t("Knight")  , value : false , selected : false},
                      { index : 2, piece : t("Bishop")  , value : false , selected : false},
                      { index : 3, piece : t("Queen")  , value : false , selected : false},
                        ])

const resetTrigger = computed({
    get() {
      return props.resetTrigger
    }
  })

const setBackground = computed({
    get() {
      return props.setBackground
    }
  })

watch(resetTrigger, (newVal,oldVal) => {
  //console.log('*********** reset trigger changed',newVal)

  // see if background needs to be set
  const mainChar = (props.piece.substring(0,1) == 'K') ? 'N' : props.piece.substring(0,1)
  
  for (var i=0; i < 4; i++) {
    pieceList.value[i].value = false
    pieceList.value[i].selected = false
    pieceList.value[i].goodAnswer = false
  }
})

watch(setBackground, (newVal,oldVal) => {
  //console.log('*********** setBackground changed',newVal)

  const mainChar = (props.piece.substring(0,1) == 'K') ? 'N' : props.piece.substring(0,1)
  
  const setBackgroundArray = newVal.split("|")
  for (var i=0; i < 4; i++) {
    pieceList.value[i].goodAnswer = false

    const targetChar = (pieceList.value[i].piece.substring(0,1) == 'K') ? 'N' : pieceList.value[i].piece.substring(0,1)
    const twoChar = mainChar + targetChar
    for (var j=0; j < setBackgroundArray.length; j++)
      if (twoChar == setBackgroundArray[j]) {
        pieceList.value[i].goodAnswer = true
        break
      }
  }
})

function onClick(event,index) {
  //console.log("Click",index)
  pieceList.value[index].selected = !pieceList.value[index].selected
  emit("checkbox-click",props.piece,pieceList.value[index].piece,pieceList.value[index].selected)
}
 
</script>

<style scoped>

#piece-container {
  position : relative;
  padding : 5px 0px;
  line-height: 1.4em;
  width : 80px;
  height: 260px;
  overflow-y: auto;
}

.piece-heading {
  background: #4c6ca0;
  color : white;
}

.piece-heading-portrait {
 padding-left : 10px;
}

.guarding-button {
  padding: 2px;
  border : dotted 1px lightgrey;
  border-radius: 3px;
  padding: 10px;
  margin-top : 5px;
  margin-left : 3px;
  text-align: center;
}
.not-selected-text-dark {
  color : #fff;
  background : black;

}

.not-selected-text-light {
  color : black;
  background : white;
}

.selected-text-light {
  color : blue;
  background : lightblue;
}

.selected-text-dark {
  color : #fff;
  background : gray;
}

.just-text {
  color : grey;
  margin-top : 12px;
  margin-bottom : 6px;
  margin-left : 8px;
  text-align: left;
  font-style: italic;
}

.button-background-white {
  background-color: white;
  color : black;
  border : solid 1px black;
  border-radius: 3px;
  margin : 5px;
  padding : 8px;
}

.error-border-light {
  box-shadow: 0 0 0 2px #000, inset 0 0 0 1px #fff;
}

.error-border-dark {
  box-shadow: 0 0 0 2px #fff, inset 0 0 0 1px #000;
}
</style>